import {
  Breakpoints,
  TextAppearance,
  TextColor,
  TextCustom,
  TextCustomProps,
  TextLineHeight,
  TextSize,
  useIsMobile,
} from '@vw-marketing/us-components';
import React from 'react';
import { DealerDetailIcon, DealerDetailText, DealerDetailWrapper, StyledIcon } from './styles';

interface DealerInformationDetailProps {
  Icon: any;
  label1?: string | JSX.Element | undefined;
  label2?: string | JSX.Element | undefined;
}

const labelTextStyle: TextCustomProps = {
  appearance: TextAppearance.copy100,
  style: {
    [Breakpoints.default]: {
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight20,
      color: TextColor.inherit,
    },
    [Breakpoints.b1600]: {
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight24,
      color: TextColor.inherit,
    },
  },
};

export const DealerInformationDetail = ({
  Icon,
  label1,
  label2,
}: DealerInformationDetailProps) => {
  const isMobile = useIsMobile(Breakpoints.b560)
  return (
    <DealerDetailWrapper>
      <DealerDetailIcon>
        <StyledIcon>
          <Icon iconSize={isMobile ? '14' : '24'} variant={isMobile ? 'small' : 'default'}/>
        </StyledIcon>
      </DealerDetailIcon>
      <DealerDetailText>
        <TextCustom {...labelTextStyle}>{label1}</TextCustom>
        <TextCustom {...labelTextStyle}>{label2}</TextCustom>
      </DealerDetailText>
    </DealerDetailWrapper>
  );
};
